import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { SalesFeesPage as SalesFeesPageBase } from './SalesFeesComponents';
import { SalesFeesViewHeader, SalesFeesTable } from './SalesFeesViewComponents';
import { BorderLine, SalesFeeUpdateModal } from '../../design-system';
import { useStore } from '../../context';
import { useSalesFeeQuery } from '../../hooks';
import { RoleGuard } from '../../routes';

const SalesFeesPage = styled(SalesFeesPageBase)`
  grid-template-rows: initial;
  grid-auto-rows: max-content;
`;

export const SalesFeesView = () => {
  const params = useParams();
  const {
    state: {
      user: { data: user },
    },
  } = useStore();
  const { data, isFetching, refetch } = useSalesFeeQuery(user, params.id, 'desc');

  if (isFetching) return <></>;
  if (!data) return <Navigate to={'/dashboard/sales-fees'} replace />;

  return (
    <RoleGuard roles={'adminRead'}>
      <SalesFeesPage>
        <SalesFeesViewHeader />
        {data.feeRecords.map((feeRecords, i: number) => (
          <React.Fragment key={'sales-fee-table' + i}>
            {i !== 0 ? <BorderLine space={'none'} /> : null}
            <SalesFeesTable data={data} feeRecords={feeRecords} user={user} refetch={refetch} />
          </React.Fragment>
        ))}
      </SalesFeesPage>
      <SalesFeeUpdateModal />
    </RoleGuard>
  );
};
